/** @jsxImportSource @emotion/react */
import { createStyles, Typography } from '@quickbit/qb-design-system';
import { Paragraph, Section } from '../components';

export const Success = ({
  merchantName,
  email,
}: {
  merchantName: string;
  email?: string;
}) => {
  const styles = useStyles();
  return (
    <Section>
      <div css={styles.block}>
        <Typography variant="heading1">Sign-Up Successful!</Typography>
        <Paragraph>
          Welcome to Quickbit Pay, <strong>{merchantName}</strong>
        </Paragraph>
        {email && (
          <div css={styles.block}>
            <Paragraph>
              Your merchant profile is created and we’ve sent a confirmation
              email to
              <br />
              <strong>{email}.</strong>
            </Paragraph>
          </div>
        )}
      </div>

      <div css={styles.block}>
        <Typography variant="bodyBold">What Happens Next?</Typography>
        <Paragraph>
          Account Review: Our team is now reviewing your submission. This
          typically takes 2-4 business days. Additional information: You may
          receive an email requesting additional documentation and/or
          information. Activation: Once approved, your account will be activated
          and you’ll be ready to start accepting payments.
        </Paragraph>
      </div>
    </Section>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  block: {
    marginBottom: spacing.xxxs,
  },
}));
